import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { EntityTableMaintainance, downloadEntity } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import { getPaginationCount } from "../CashAllocation/utils";
import { CommonPaginationContainer } from "../common";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  TableContainer,
  Tooltip,
  Typography,
} from "@mui/material";
import EntityDetails from "./EntityDetails";
import CloseIcon from "@mui/icons-material/Close";
import { AddEntityDetails } from "./AddEntity";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ViewAndEditEntity } from "./ViewAndEditEnitty";
import { commonToast } from "../common";
import format from "date-fns/format";
import "../common/commonPageStyles.css";
import {
  primaryButtonStyle,
  secondaryButtonStyle,
  downloadButtonStyle,
  updateButtonStyle,
  submitButtonStyle,
  getDeleteButtonStyle,
  addButtonStyle,
  primaryButtonHoverColor,
} from "../common/commonButtonStyles";

//styles

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",
};
const EditPageContainerTransactionsList = {
  display: "flex",
  justifyContent: "end",
  width: "100%",
  alignItems: "center",
  marginBottom: "10px",
};

const ResetSubmit = {
  justifyContent: "flex-end",
  paddingTop: "0px",
  marginRight: "12px",
};

const CloseIconStyle = {
  backgroundColor: "#3B3F44",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};

export default function EntityContainer() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const classes = useStyles();
  const [rows, setRows] = useState([{ entity_divisions: "", entity_name: "" }]);
  const [tableRows, setTableRows] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [EntityDialog, setEntityDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    page: 1,
    pageSize: 25,
  });
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([false]);

  useEffect(() => {
    setPaginationCount(getPaginationCount(tableRows?.length ?? 0, pageState?.pageSize ?? 25));
  }, [tableRows?.length, pageState?.pageSize]);

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
  };

  const handleDialogClose = () => {
    setEntityDialog(false);
    setEditMode(false);
    setViewMode(false);
    if (!editMode && !viewMode) {
      setRows([{ entity_divisions: "", entity_name: "" }]);
      setSelectedRows([false]);
      setValidationStatus([true]);
    }
    else if (editMode) {
      setValidationStatus([true]);
      setCurrentUpdatedFiledsInEditMode({});
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    let filteredData;
    if (value.trim() === "") {
      loadData();
      filteredData = tableRows;
    } else {
      filteredData = tableRows.filter((row) =>
        columns.some((column) => {
          const cellValue = row[column.field];
          if (Array.isArray(cellValue)) {
            // Check if the array is not null
            if (cellValue !== null && cellValue !== undefined) {
              // Check if any property within the objects in the array includes the search value
              return cellValue.some((item) =>
                Object.values(item).some(
                  (propValue) =>
                    propValue !== undefined &&
                    propValue !== null &&
                    propValue.toString().includes(value)
                )
              );
            }
          } else if (cellValue !== undefined && cellValue !== null) {
            // For non-array fields, continue with the existing logic
            return cellValue.toString().includes(value);
          }
          return false;
        })
      );
    }
    setTableRows(filteredData);
  };
  // const handleCheckboxChange = (index, isChecked) => {
  //   console.log("selected Rows123", selectedRows)
  //   const updatedRows = [...rows];
  //   updatedRows[index] = isChecked;
  //   console.log("selectted rows", updatedRows)
  //   // Check the number of selected rows
  //   const updatedSelectedRows=updatedRows.filter(Boolean)
  //   const selectedRowCount = updatedSelectedRows.filter(Boolean).length;

  //   setSelectedRows(updatedSelectedRows);
  //   setSelectAll(selectedRowCount === rows.length);
  // };

  useEffect(() => {
    if (selectAll) {
      const updatedSelectedRows = [...selectedRows];
      updatedSelectedRows.fill(selectAll);
      setSelectedRows(updatedSelectedRows);
    }
  }, [selectAll]);

  const handleCheckboxChange = (index, isChecked) => {
    const updatedSelectedRows = [...selectedRows];
    updatedSelectedRows[index] = isChecked;
    // Check the number of selected rows
    const selectedRowCount = updatedSelectedRows.filter(Boolean).length;

    setSelectedRows(updatedSelectedRows);
    setSelectAll(selectedRowCount === rows.length);
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      entity_divisions: "",
      entity_name: "",
    }));
    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRows([{ ...rowData }]);
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRows([rowData]);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRows(emptyRows);
      setIsCreated(true);
      setEntityDialog(true);
    }
    setEntityDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };

  const handleReset = () => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      entity_divisions: "",
      entity_name: ""
    }));
    setRows(emptyRows);
    setSelectedRows(selectedRows.fill(false))
    setSelectAll(false);
    setValidationStatus(Array.from({ length: rows.length }, () => true));
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3, headerAlign: "center" },
    {
      field: "entity_divisions",
      headerName: "Entity Divisions",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "entity_name",
      headerName: "Entity Name",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-"
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-"
    },
    ...(userData?.role !== "CC Processor" ? [{
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 0.8,
      cellClassName: "actions",
      getActions: ({ row }) => {
        let actionsList = [];

        if (UserAuthorisation?.["Edit"] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={
                <Tooltip title="Edit">
                  {" "}
                  <EditIcon />{" "}
                </Tooltip>
              }
              label="Edit"
              className="textPrimary"
              onClick={() => handleActionButton(row, true)}
              color="inherit"
            />
          );
        }

        // if (bankTransactions?.['Delete'] === "Y") {
        //   actionsList.push(
        //     <GridActionsCellItem
        //       icon={<Tooltip title="Delete"><DeleteIcon /> </Tooltip>}
        //       label="Delete"
        //       onClick={() => handleDeleteClick(row.id)}
        //       color="inherit"
        //     />
        //   );
        // }

        if (UserAuthorisation?.["View"] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={<VisibilityIcon />}
              label="view"
              className="textPrimary"
              onClick={() => handleActionButton(row, false)}
              color="inherit"
            />
          );
        }

        return actionsList;
      },
    }] : [
      {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        flex: 0.8,
        cellClassName: "actions",
        getActions: ({ row }) => {
          let actionsList = [];

          // if (UserAuthorisation?.['View'] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={<VisibilityIcon />}
              label="view"
              className="textPrimary"
              onClick={() => handleActionButton(row, false)}
              color="inherit"
            />
          );
          // }

          return actionsList;
        },
      }
    ]),
  ];
  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      const resp = await instance.get(EntityTableMaintainance);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(sortedData);
      } else {
        setTableRows([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };
  const UserAuthorisation =
    userData?.user_permissions?.permissions_list["Admin Table Maintenance"];

  useEffect(() => {
    loadData();
  }, []);

  const handleInputChange = (index, colName, value) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      updatedRows[index][colName] = value;
      setRows(updatedRows);
      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedSelectedRows = new Array(rows.length).fill(isChecked);

    setSelectedRows(updatedSelectedRows);
    setSelectAll(isChecked);
  };

  const handleAddRow = () => {
    // console.log("adding row", rows, selectedRows);
    setRows([...rows, { entity_divisions: "", entity_name: "" }]);
    setSelectedRows([...selectedRows, false]);
  };

  useEffect(() => {
    const selectedRowCount = selectedRows.filter(Boolean).length;
    if (selectedRowCount < rows.length) {
      setSelectAll(false);
    }
  }, [rows, selectedRows]);

  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows(selectedRows.filter((ele) => !ele));
    setSelectAll(false);
  };
  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.entity_divisions || !/^[a-zA-Z0-9]{4,}$/.test(row.entity_divisions)) {
      fieldValidations.entity_divisions = "Entity Divisions must be of 4 or more alphanumeric characters";
    }

    if (!row || !row.entity_divisions || row.entity_divisions.trim() === "") {
      fieldValidations.entity_divisions = "This field is required";
    }

    if (!row || !row.entity_name || row.entity_name.trim() === "") {
      fieldValidations.entity_name = "This field is required";
    }

    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };
  const handleSubmit = async () => {
    // Validate each row before submission
    const areRowsValid = rows
      .map((_, index) => validateRow(index))
      .every((value) => value);
    let editModeObj = {};
    if (editMode) {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";
      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }
    //const areRowsValid = true;

    if (!areRowsValid) {
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fill all required fields.");
      return;
    }

    try {
      let response;
      if (editMode) {
        response = await instance.patch(
          EntityTableMaintainance + editId + "/",
          editModeObj
        );
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        // const flattenedRows = rows.flat();
        rows.forEach((item) => {
          item.created_by = userData?.user_name ?? "";
        });
        response = await instance.post(EntityTableMaintainance, rows);
      }

      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      if (err.data.Duplicates) {
        commonToast("error", `${err.data.Duplicates}`);
        loadData()
      }
      else {
        commonToast("error", "Submission failed. Please try again.");
      }
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };
  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadEntity}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `Entity_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Entity data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Entity data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Entity data could not be downloaded");
    }
  }
  return (
    <div style={Container}>
      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Typography variant="h5" className="page-heading">
            Entity Table
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {UserAuthorisation?.["Creation"] === "Y" && (
              <>
                <CommonButton
                  text="Add"
                  handleClick={() => handleActionButton()}
                  sx={primaryButtonStyle}
                  hoverColor={primaryButtonHoverColor}
                />
                <CommonButton
                  text="Export"
                  handleClick={handleDownloadBtnClick}
                  sx={downloadButtonStyle}
                  hoverColor={primaryButtonHoverColor}
                  disabled={isDownloadInProgress}
                />
              </>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "hidden",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            width: "100%",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
          }}
        >
          <DataGrid
            className={classes.pagination}
            loading={isApiCallInprogress}
            rows={tableRows ?? []}
            columns={columns}
            rowCount={tableRows?.length ?? 0}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            getRowId={(row) => row?.id}
            autoHeight={false}
            pagination
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 25}
            onPageSizeChange={(newPageSize) => {
              setPageState((old) => {
                setPaginationCount(getPaginationCount(tableRows?.length ?? 0, newPageSize));
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            components={{
              Toolbar: () => null,
              NoRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  No Entity Table Records
                </Stack>
              ),
            }}
            sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              width: "100%",
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
                width: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "12px 16px",
                borderBottom: "none",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "600",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "#1672DE",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "#1672DE",
                },
              },
              "& .MuiDataGrid-columnHeader[data-field='actions']": {
                minWidth: toggle?.isOpen
                  ? "248px !important"
                  : "289px !important",
              },
              "& .MuiDataGrid-row": {
                transition: "all 0.2s ease",
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(22, 114, 222, 0.08) !important",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.12) !important",
                  },
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f0f0f0",
                padding: "12px 16px",
                fontSize: "13px",
                color: "#333",
                display: "flex",
                alignItems: "center",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-virtualScroller": {
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "2px solid #e0e0e0",
                borderBottom: "none",
                backgroundColor: "#f8f9fa",
                minHeight: "56px",
                maxHeight: "56px",
                paddingBottom: "8px",
                paddingTop: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                position: "relative",
                zIndex: 1,
                display: "flex",
                alignItems: "center",
                "& .MuiTablePagination-root": {
                  color: "#666",
                  paddingRight: "16px",
                  margin: 0,
                  minHeight: "32px",
                },
                "& .MuiTablePagination-selectLabel": {
                  fontSize: "13px",
                  margin: 0,
                },
              },
            }}
          />

          {/* Page number buttons beside "Showing x–y of z entries" */}
          <Box
            sx={{
              position: "absolute",
              right: 16,
              bottom: 14,
              zIndex: 2,
              display: "flex",
              alignItems: "center",
            }}
          >
            <CommonPaginationContainer
              count={paginationCount + 1}
              pageState={pageState}
              setPageState={setPageState}
            />
          </Box>
        </Box>
      </Box>
      {/* <EntityDetails /> */}
      <Dialog
        open={EntityDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ cursor: "default", paddingBottom: "0px" }}
        >
          {viewMode ? "View Entity" : editMode ? "Edit Entity" : "Add Entity"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon style={CloseIconStyle} />
          </IconButton>
          <hr style={{ width: "100%" }} />
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "0px 24px 5px 24px" }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {!editMode && !viewMode && (
              <div style={EditPageContainerTransactionsList}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <CommonButton
                    sx={addButtonStyle}
                    text="Add"
                    handleClick={handleAddRow}
                    icon={<AddIcon style={{ height: "18px" }} />}
                    hoverColor={primaryButtonHoverColor}
                  />
                  <CommonButton
                    sx={getDeleteButtonStyle(selectAll)}
                    text="Delete"
                    handleClick={handleDeleteRow}
                    disabled={selectedRows.filter(Boolean).length === 0}
                    icon={<DeleteIcon style={{ height: "19px" }} />}
                  />
                </div>
              </div>
            )}
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddEntityDetails
                  selectAll={selectAll}
                  handleInputChange={handleInputChange}
                  handleSelectAll={handleSelectAll}
                  rows={rows}
                  // handleBlur={handleBlur}
                  handleCheckboxChange={handleCheckboxChange}
                  validationStatus={validationStatus}
                  selectedRows={selectedRows}
                />
              </TableContainer>
            ) : (
              <>
                {rows?.map((row, index) => (
                  <Grid display={"flex"} flexDirection={"column"} width={"400px"}>
                    <ViewAndEditEntity
                      row={row}
                      index={index}
                      viewMode={viewMode}
                      validationStatus={validationStatus}
                      editMode={editMode}
                      handleInputChange={handleInputChange}
                    />
                  </Grid>
                ))}
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions
          sx={{
            backgroundColor: "#ffffff",
            padding: "16px 24px",
            borderTop: "1px solid #e0e0e0",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                  hoverColor="rgba(22, 114, 222, 0.05)"
                  sx={{
                    backgroundColor: "transparent",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.05)",
                      borderColor: "#1565c0",
                      color: "#1565c0",
                    },
                    "&:disabled": {
                      backgroundColor: "transparent",
                      color: "rgba(0, 0, 0, 0.26)",
                      borderColor: "#e0e0e0",
                    },
                  }}
                />
              )}
              {editMode && (
                <CommonButton
                  text="Update"
                  handleClick={handleSubmit}
                  disabled={Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
                      transform: "translateY(-1px)",
                    },
                    "&:disabled": {
                      backgroundColor: "#e0e0e0",
                      color: "#9e9e9e",
                      boxShadow: "none",
                      transform: "none",
                    },
                  }}
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  text="Submit"
                  handleClick={handleSubmit}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
                      transform: "translateY(-1px)",
                    },
                  }}
                />
              )}
              <CommonButton
                text="Cancel"
                handleClick={handleDialogClose}
                hoverColor="rgba(22, 114, 222, 0.05)"
                sx={{
                  backgroundColor: "transparent",
                  color: "#1672DE",
                  border: "1px solid #1672DE",
                  borderRadius: "10px",
                  padding: "10px 24px",
                  fontWeight: "600",
                  fontSize: "14px",
                  textTransform: "none",
                  minHeight: "40px",
                  minWidth: "120px",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.05)",
                    borderColor: "#1565c0",
                    color: "#1565c0",
                  },
                }}
              />
            </>
          )}
          {viewMode && (
            <CommonButton
              text="Close"
              handleClick={handleDialogClose}
              hoverColor="rgba(22, 114, 222, 0.05)"
              sx={{
                backgroundColor: "transparent",
                color: "#1672DE",
                border: "1px solid #1672DE",
                borderRadius: "10px",
                padding: "10px 24px",
                fontWeight: "600",
                fontSize: "14px",
                textTransform: "none",
                minHeight: "40px",
                minWidth: "120px",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.05)",
                  borderColor: "#1565c0",
                  color: "#1565c0",
                },
              }}
            />
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
